import { render, staticRenderFns } from "./updateLog.vue?vue&type=template&id=06deff9b&scoped=true"
import script from "./updateLog.vue?vue&type=script&lang=js"
export * from "./updateLog.vue?vue&type=script&lang=js"
import style0 from "./updateLog.vue?vue&type=style&index=0&id=06deff9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06deff9b",
  null
  
)

export default component.exports